import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import UserOnglet from "../../user/UserOnglet";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicSignalAnnonce = () => {
  const { setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
    { label: 'Signaler un problème', link: '/topics/securite/signal-probleme'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Si vous remarquez une annonce sur Wodzone qui vous préoccupe, nous vous demandons de la signaler. 
              Votre signalement nous aidera à assurer la sécurité de l'ensemble de la communauté Wodzone.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Voici quelques-unes des raisons de signaler une annonce :
              </p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text">Contenu inapproprié</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Compétition fictif</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Tentatives d'escroquerie ou d'hameçonnage</p></li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Signaler une annonce sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">Appuyez sur l'annonce à signaler.</p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Tout en bas de la page de détail de l'annonce, cliquez sur <strong>Signaler cette annonce</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Sélectionnez la raison pour laquelle vous signalez l'annonce, puis cliquez sur <strong>Suivant.</strong></p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Donnez davantage de détails (le cas échéant), puis cliquez sur <strong>Envoyer.</strong></p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Signaler une annonce sur navigateur mobile</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyez sur <strong>Profil</strong> {'>'} <strong>Compte</strong> {'>'}
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Informations personnelles.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Accédez à la section <strong>Numéro de téléphone</strong>, appuyez sur <strong>Modifier</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Effectuez vos modifications, puis appuyez sur <strong>Enregistrer</strong>.</p></li>
                    </ol>
                  </div>
              }
            </div>  
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicSignalAnnonce